module.exports = __webpack_public_path__ + "static/media/008.db67ab18.jpg";